import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null)); }, [slug]);

  if (post === undefined) return <p className="text-slate-400 text-center py-10">Chargement…</p>;
  if (post === null) return <p className="text-slate-400 text-center py-10" data-testid="blog-notfound">Article introuvable.</p>;

  return (
    <article className="max-w-3xl mx-auto" data-testid="blog-detail">
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-[#C85A32] font-semibold mb-4"><ArrowLeft className="w-4 h-4" /> Retour au blog</Link>
      {post.image && <img src={post.image} alt={post.title} className="w-full h-64 object-cover rounded-2xl mb-6" />}
      <p className="text-xs text-slate-400">{formatDate(post.created_at)}</p>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#0F172A] mt-1 mb-4">{post.title}</h1>
      <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: post.content || "" }} />
    </article>
  );
}
